module.exports = __webpack_public_path__ + "img/52.c31936b8.jpg";